import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom'
import Login from './Login/Login'
import TournamentsList from './Tournament/TournamentsList'
import PrivateRoute from './PrivateRoute'
import TournamentOpen from './Tournament/HomeCard/TournamentOpen'
import CreateTournament from './Tournament/CreateTournament'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import { getData } from './api/indexedDBHandler'
import UserName from './Login/UserName'
import { useDispatch, useSelector } from 'react-redux'
import { loginSuccess, nameSuccess, logout } from './slices/authSlice'
import StatusRequestsBar from './Header/StatusRequestsBar'
import SnackbarProvider from './alert/SnackbarProvider' // Импортируйте SnackbarProvider
import TournamentDraw from './Tournament/TournamentDraw'
import './App.css'
import TeamRequests from './Team/TeamRequests'
import TournamentAccess from './Tournament/TournamentAccess'
import TournamentWeighing from './Tournament/TournamentWeighing'

import TournamentSettings from './Tournament/TournamentSettings'
import TournamentTeams from './Tournament/TournamentTeams'
import TournamentSocial from './Tournament/Social/TournamentSocial'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import TournamentDocumentation from './Tournament/TournamentDocumentation'

const App = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
  const isUserNameRequired = useSelector((state) => state.auth.user)

  const theme = createTheme({
    palette: {
      warning: {
        main: '#ffeb3b', // Желтый цвет
        contrastText: '#000', // Черный текст для контраста
      },
    },
  })

  useEffect(() => {
    const checkUserData = async () => {
      try {
        const results = await getData('user', 'created', true)
        const { value } = results[0] || {}
        //  console.log('value', value)
        //   console.log(!value, value.verify == false, !value.phone)

        if (!value || value.verify == false || !value.phone) {
          //  console.log('1')
          dispatch(logout())
        } else if (!value.name || !value.surname) {
          //  console.log('2')
          dispatch(loginSuccess(true))
          dispatch(nameSuccess(false))
        } else {
          //console.log('3')
          dispatch(loginSuccess(true))
          dispatch(nameSuccess(true))
        }
      } catch (error) {
        console.error('Ошибка при получении данных пользователя:', error)
        dispatch(logout())
      }
    }

    checkUserData()
  }, [])
  //console.log('isAuthenticated', isAuthenticated)
  //console.log('isUserNameRequired', isUserNameRequired)

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    )
  }
  if (!isUserNameRequired) {
    return <UserName />
  }

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <Router>
          <Header />
          <StatusRequestsBar />
          <main>
            <Routes>
              <Route
                path="/tournaments/:id/weighing"
                element={
                  <PrivateRoute>
                    <TournamentWeighing />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/settings"
                element={
                  <PrivateRoute>
                    <TournamentSettings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/teams"
                element={
                  <PrivateRoute>
                    <TournamentTeams />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/social"
                element={
                  <PrivateRoute>
                    <TournamentSocial />
                  </PrivateRoute>
                }
              />

              <Route
                path="/tournaments/:id/draw"
                element={
                  <PrivateRoute>
                    <TournamentDraw />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/access"
                element={
                  <PrivateRoute>
                    <TournamentAccess />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id"
                element={
                  <PrivateRoute>
                    <TournamentOpen />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/documentation"
                element={
                  <PrivateRoute>
                    <TournamentDocumentation />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-tournament"
                element={
                  <PrivateRoute>
                    <CreateTournament />
                  </PrivateRoute>
                }
              />
              <Route
                path="/team-requests"
                element={
                  <PrivateRoute>
                    <TeamRequests />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments-list"
                element={
                  <PrivateRoute>
                    <TournamentsList />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<Navigate to="/tournaments-list" />} />
              <Route path="*" element={<Navigate to="/tournaments-list" />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default App
